import { render } from "./bookingclinic.vue?vue&type=template&id=d2d9d18c&scoped=true"
import script from "./bookingclinic.vue?vue&type=script&lang=js"
export * from "./bookingclinic.vue?vue&type=script&lang=js"

import "./bookingclinic.vue?vue&type=style&index=0&id=d2d9d18c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d9d18c"]])

export default __exports__